<template>
  <div>
    <RouterView class="router-view" v-slot="{ Component }">
      <Transition mode="out-in">
        <component
          :is="currentComponent || Component"
        />
      </Transition>
    </RouterView>
  </div>

</template>

<script setup name="list">
import { computed, onMounted } from 'vue'
import { dataRcd } from '../store'

const currentComponent = computed(() => dataRcd.getters.getActiveComponent)

onMounted(() => {
  dataRcd.dispatch('setComponentActiveUnidade')
})
</script>

<style scoped lang="scss">
.v-enter-from,
.v-leave-to {
  transform: translate(50px);
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}
</style>
